import {connect} from "react-redux";
import ValidationError from "~/Components/Forms/ValidationError";
import {SingleDatePicker} from "react-dates";
import React, {useState} from "react";

const AdminHostInvitationForm = ({values, errors, onChange}) => {

    const [dateFocused, setDateFocused] = useState(false);

    const defaultFields = {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        company: '',
        job_title: '',
    };

    const form = {...defaultFields, ...values};

    const handleDeadlineChange = (date) => {
        let formData = {...form, 'deadline': date};
        onChange(formData);
    };

    const handleChange = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        let formData = {...form, [name]: value};

        onChange(formData);
    };

    return (
        <form>
            <div className="form-group required">
                <label>Personal Message</label>

                <textarea
                    onChange={handleChange}
                    value={form.message}
                    name="message"
                    type="text"
                    className="form-control textarea-message"
                    placeholder="Type here"/>

                <ValidationError errors={errors} name="message"/>
            </div>

            <div className="form-group required">
                <label>Deadline</label>

                <div>
                    <SingleDatePicker
                        keepOpenOnDateSelect={false}
                        hideKeyboardShortcutsPanel={true}
                        openDirection={'up'}
                        numberOfMonths={1}
                        date={form.deadline}
                        onDateChange={(date) => handleDeadlineChange(date)}
                        focused={dateFocused}
                        onFocusChange={(f) => setDateFocused(f.focused)}
                        id="deadline"
                    />
                </div>

                <ValidationError errors={errors} name="deadline"/>
            </div>
        </form>
    )

}

export default AdminHostInvitationForm;
